'use strict';

import './scripts/bootstrap';
import Vue from 'vue';
import App from './vue-components/login/App.vue';

new Vue({
  el: '#app',
  render (h) {
    return h(App);
  }
});



// WEBPACK FOOTER //
// ./client/app/login.js